import { FormControlLabel, Popover } from "@material-ui/core";
import React, { useState } from "react";

import ChevronDownIcon from "@shared/icons/ChevronDownIcon";
import StyledCheckbox from "@shared/customComponents/StyledCheckbox";

const PopoverMultiselect = ({
  currentFilter,
  title,
  setFilter,
  filters,
  options,
  compact,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (option) => {
    const currentSelections = filters[currentFilter] || [];
    const isSelected = currentSelections.some(
      (item) => item.value === option.value
    );

    const newSelections = isSelected
      ? currentSelections.filter((item) => item.value !== option.value)
      : [...currentSelections, option];

    setFilter({ ...filters, [currentFilter]: newSelections });
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <button
        className={`flex items-center gap-8 md:text-16 border !border-transparent rounded-md  p-4 hover:shadow-xl ${
          compact ? "!text-14 text-[#374151] font-medium" : "text-16"
        }`}
        onClick={handleClick}
        type="button"
      >
        {title}{" "}
        {filters[currentFilter]?.length > 0 ? (
          <span
            className={`text-10 text-black rounded  h-16 w-16 flex items-center justify-center ${
              compact ? "bg-grey-300" : "bg-white"
            }`}
          >
            {filters[currentFilter].length}
          </span>
        ) : (
          ""
        )}{" "}
        <ChevronDownIcon className="w-10" />
      </button>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={handleClose}
        open={open}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div className="flex flex-col gap-4  my-0 p-8 border border-grey-200 rounded">
          {options.map((option) => (
            <FormControlLabel
              className="gap-8 px-8  mx-0 hover:bg-grey-200 rounded-md w-full"
              control={
                <StyledCheckbox
                  checked={filters[currentFilter]?.some(
                    (item) => item.value === option.value
                  )}
                  color="primary"
                  disableRipple
                  onChange={() => handleCheckboxChange(option)}
                />
              }
              key={option.value}
              label={option.label}
              labelPlacement="end"
            />
          ))}
        </div>
      </Popover>
    </div>
  );
};

export default PopoverMultiselect;
